import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBook = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			opacity: .4,
			d: "M10.998 20.3868C11.2768 20.4466 11.462 20.4806 11.6486 20.497C11.8811 20.5173 12.115 20.5173 12.3475 20.497C12.5341 20.4806 12.7193 20.4466 12.998 20.3868V5.38759C12.6367 5.46785 12.4494 5.50857 12.2601 5.52517C12.0857 5.54046 11.9104 5.54046 11.736 5.52517C11.5467 5.50857 11.3594 5.46785 10.998 5.38759V20.3868Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13 5.38745C13.0135 5.38445 13.0273 5.38139 13.0413 5.37828L18.0794 4.2587C19.078 4.03677 19.5774 3.92581 19.9692 4.05488C20.3128 4.16805 20.604 4.40159 20.789 4.71246C21 5.06701 21 5.57852 21 6.60155V16.0427C21 16.9587 21 17.4166 20.8377 17.7945C20.6945 18.1279 20.4634 18.416 20.1691 18.6281C19.8354 18.8685 19.3883 18.9678 18.4942 19.1665L13.3884 20.3011C13.2396 20.3342 13.1122 20.3625 13 20.3866V5.38745Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11 5.38745V20.3866C10.8878 20.3625 10.7605 20.3342 10.6118 20.3012L5.50582 19.1665C4.61171 18.9678 4.16464 18.8685 3.83093 18.6281C3.53658 18.416 3.30545 18.1279 3.1623 17.7945C3 17.4166 3 16.9587 3 16.0427V6.60155C3 5.57852 3 5.06701 3.21101 4.71246C3.39602 4.40159 3.68715 4.16805 4.03076 4.05488C4.42263 3.92581 4.92197 4.03677 5.92063 4.2587L10.9587 5.37828C10.9727 5.38139 10.9865 5.38445 11 5.38745Z",
			fill: "currentColor"
		})
	]
});
const ForwardRef = forwardRef(SvgBook);
export { ForwardRef as ReactComponent };
